import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "link"];

  remove() {
    this.inputTarget.remove();
    this.element.classList.add("removed");
  }
}
